import { render, staticRenderFns } from "./ModalAddUsersAccess.vue?vue&type=template&id=1c851ec2&"
import script from "./ModalAddUsersAccess.vue?vue&type=script&lang=js&"
export * from "./ModalAddUsersAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports